export default (theme: any) => ({
    buttonsContainer: {
        width: '100%',
    },

    buttonsContainerButtons: {
        width: '100%',
        marginTop: '2rem',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '1rem',
        [theme.breakpoints.up(720)]: {
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'row',
        },
    },

    button: {
        width: '100%',
        [theme.breakpoints.up(720)]: {
            width: 'auto',
        },
    },

    deleteButton: {},
    cancelButton: {},

    saveButton: {
        minWidth: '15rem',
    },
})
